import React, { useContext, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import moment from 'moment-timezone';
import { AuthenticationContext } from '../services/authentication/authentication.context';
import { SaveChanges } from './utility/save-changes';
import { SuccessMsg } from './utility/success-msg';

export const UserTimezone = () => {
  const timeZonesList = moment.tz.names();
  const { userPreferTime, setUserPreferTime, savePreferTime } = useContext(
    AuthenticationContext
  );

  const [show, setShow] = useState(false);

  return (
    <div>
      <Autocomplete
        value={userPreferTime && userPreferTime.user_timezone}
        disableClearable
        onChange={(event, value) => {
          setUserPreferTime({
            ...userPreferTime,
            user_timezone: value,
          });
        }}
        options={timeZonesList}
        size='small'
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              userPreferTime && userPreferTime.user_timezone
                ? 'Time Zone'
                : 'Select a Time Zone'
            }
            variant='standard'
          />
        )}
      />
      <SaveChanges
        route={'/meetings'}
        click={savePreferTime}
        id='timezone'
        setShow={setShow}
      />
      <SuccessMsg show={show} setShow={setShow} />
    </div>
  );
};
